export default __webpack_public_path__ + "static/media/안주10.3d81c8a8.jpg";